import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useSnackbar } from "notistack";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { PermissionWrapper } from "../../../../wrappers";
import { ButtonLoader } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import CalenderList from "../components/CalenderList";
import CalenderCRU from "../components/CalenderCru";
import { deleteCalenderApi, getCalenderListApi } from "../apiService";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { useNavigate } from "react-router";
import SettingPageLayout from "../../../elements/SettingPageLayout";
import { RoleBaseAccess } from "../../../../hoc";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const CalenderHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Calendar`, page_type: page_type, })
    }

    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['D'] }}>
                        <Checkbox
                            color="primary"
                            size="small"
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
                            checked={item?.length === bulk?.ids?.length && item?.length > 0}
                        /></PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '140px' }}>{tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: '100px' }}>{tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{ minWidth: '150px' }}>{tableSorting('effective_from', 'Effective From')}</TableCell>
                <TableCell sx={{ minWidth: '150px' }}>{tableSorting('effective_till', 'Effective Till')}</TableCell>
                <TableCell sx={{minWidth: '200px'}}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const Calender = () => {
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [calenderInfo, setcalenderInfo] = useState({ list: [], pagination: {} });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [calenderCRU, setCalenderCRU] = useState({ modal: false, data: null, mode: '' });
    const [deleteCalender, setDeleteCalender] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [isExport, setIsExport] = useState(false)

    useEffect(() => {
        getCalenderList('skeletonLoader', { per_page: 50 })
        trackActivity('Page Viewed', { page_title: 'Calendar' })
    }, [])

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getCalenderList('pageLoader', { ...sortQuery, per_page: calenderInfo?.pagination?.per_page });
    }

    const getCalenderList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getCalenderListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                setcalenderInfo(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        })
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const deleteCalenderFn = () => {
        setLoading(true);
        const idsToDelete = deleteCalender?.modal && deleteCalender?.data?.id ? [deleteCalender?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteCalenderApi(), { ids: idsToDelete } )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Party Role`, success_msg: response?.data?.message, item_ids: deleteCalender?.data || bulk?.ids, response: response?.data })
                    setDeleteCalender({ modal: false, data: null });
                    getCalenderList('', { per_page: calenderInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Party Role`, error_msg: response?.data?.message, item_ids: deleteCalender?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Calendar`, page_type: page_type, })
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = { ...query, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }
        }
        setIsExport(true);
        globalGetService(getCalenderListApi(query))
        .then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar( response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } } );
            }
            setIsExport(false);
        })
    }

    return (
        <SettingPageLayout
            actionBar={
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'5px 0px' }}>
                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => {setRevisionHistory({ modal: true, mode: '', data: {slug: "",type:"global"} }); handleItemClicked('Global Revision HistoryIcon')}} /> </li>
                    {
                        bulk?.type && bulk?.ids?.length ?
                            <>
                                <li className='lease-mobile-button'>
                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                </li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['D'] }}>
                                    <li className='lease-mobile-button'>
                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                    </li>
                                </PermissionWrapper>
                            </> : null
                    }
                    {calenderInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button onClick={() => {handleExport(); handleItemClicked("Export Button")}} startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small'> Export </Button> </li> : null}
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['C'] }}>
                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setCalenderCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Calendar </Button> </li>
                    </PermissionWrapper>
                </ul>
            }
        >
            <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: calenderInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important' }}>
                <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                    {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                        <Table className='mui-table-format' stickyHeader>
                            <CalenderHd item={calenderInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} sortInfo={sortInfo} createSortHandler={createSortHandler} />
                            <TableBody>
                                {calenderInfo?.list?.length > 0 && calenderInfo?.list?.map((item) =>
                                    <CalenderList
                                        key={item?.id}
                                        item={item}
                                        bulk={bulk}
                                        toggleBulkOps={toggleBulkOps}
                                        onEditFn={() => setCalenderCRU({ modal: true, data: item, mode: 'edit' })}
                                        ondeleteCalenderFn={() => {
                                            setDeleteCalender({ modal: true, data: item });
                                            setBulk({ modal: false, ids: [item], title: '', type: '' });
                                        }}
                                        onView={() => navigate(`/settings/calendar/view/${item.slug}`)}
                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                    />
                                )}
                            </TableBody>
                        </Table>
                    )}
                    {!skeletonLoader && calenderInfo?.list?.length === 0 && <NoRecordFound />}
                </div>
                <Paper square>
                    <Pagination
                        pagination={calenderInfo?.pagination}
                        onPageChange={(event, newPage) => { const pageNum = newPage + 1; getCalenderList("pageLoader", { page: pageNum, per_page: calenderInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getCalenderList("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                    />
                </Paper>
            </Paper>
            {calenderCRU.modal &&
                <CalenderCRU
                    calenderCRU={calenderCRU}
                    modeType={calenderCRU?.mode}
                    getResponseBack={() => getCalenderList("", { per_page: calenderInfo?.pagination?.per_page })}
                    onToggleModal={() => setCalenderCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteCalender.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteCalender.modal}
                    title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (calenderInfo?.list?.length || 0)) ? "Delete All Calendars" : "Delete Selected Calendars" : "Delete Calendar" }
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [] });
                        } else {
                            setDeleteCalender({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                    onDeleteRecords={() => deleteCalenderFn()}
                /> : null}
            { revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"calendar"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            } 

            {isLoading ? <PageLoader /> : null}
        </SettingPageLayout>
    )

};
export default RoleBaseAccess(Calender, { application: 'lease_revamp', feature: 'calendar', operationType: ['R'], settingNav: true });
